export function timetableStateSelector(state) {
  return state.local.timetable
}
